// import {BrowserRouter as Router,Route,Routes} from "react-router-dom";
// import Header from "./components/Header";
// import Home from "./components/Home";
// import "./styles/App.scss";
// import "./styles/header.scss";
// import "./styles/home.scss";

// function App() {
//   return (
//     <Router>
//     <Header/>
//     <Routes>
//       <Route path ="/" element = {}/>
//     </Routes>
//     </Router>
//   );
// }

// export default App;
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Header from "./components/Header";
import Home from "./components/Home";
import Footer from "./components/Footer";
import Services from "./components/Services";
import Contact from "./components/Contact";

import "./styles/App.scss";
import "./styles/header.scss";
import "./styles/home.scss";
import "./styles/footer.scss";
import "./styles/contact.scss";
import "./styles/mediaquery.scss";

function App() {
  return (
    <Router>
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/contact" element={<contact />} />
        <Route path="/services" element={<Services />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;

